import React from 'react';
import { type FieldValues, type Path, type PathValue } from 'react-hook-form';

import { useFormElement } from '../useFormElement';

import { type BaseCurrencyInputProps, BaseCurrencySelect } from './BaseCurrencySelect';

export type CurrencySelectProps<T extends FieldValues, FP extends Path<T>> = Omit<
	BaseCurrencyInputProps,
	'error' | 'onChange' | 'value'
> & {
	defaultValue?: PathValue<T, FP>;
	name: FP;
};

export function CurrencySelect<T extends FieldValues, FP extends Path<T> = Path<T>>({
	defaultValue,
	name,
	...props
}: CurrencySelectProps<T, FP>) {
	const {
		field: { onChange, value },
		fieldState: { error }
	} = useFormElement<T, FP>({
		defaultValue,
		name
	});

	return <BaseCurrencySelect error={error} value={value} onChange={onChange} {...props} />;
}
